import { render } from "./LoginApp.vue?vue&type=template&id=c9c37fe2"
import script from "./LoginApp.vue?vue&type=script&lang=js"
export * from "./LoginApp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__